import { Component, Input, Output, EventEmitter, SimpleChanges, ViewChild, OnInit } from '@angular/core';
import { UntypedFormBuilder, FormGroup, FormControl, Validators, ValidatorFn } from '@angular/forms';
import { ScheduledDiscovery, TimeUnit, DiscoverySettings, DiscoveryMethod } from 'DiscoveryEngine.TS/Discovery';
import { ScheduleType, Schedule, ScheduleDayOfWeek, ScheduleMonth, ScheduleOrdinal } from 'DiscoveryEngine.TS/Utils';
import { SchedDiscConfigComponentBase } from "../SchedDiscConfigComponentBase";
import { NetFacadeService } from 'netview';
import { ScheduleComponent } from 'base';

@Component({
	selector: 'sched-disc-config-schedule',
	templateUrl: './sched-disc-config-schedule.component.html',
	styleUrls: ['./sched-disc-config-schedule.component.scss']
})
export class SchedDiscConfigScheduleComponent extends SchedDiscConfigComponentBase implements OnInit {

    @ViewChild(ScheduleComponent, { static: true })
	public schedComponent: ScheduleComponent;

	public schedule: Schedule;

	constructor(private fb: UntypedFormBuilder, netFacadeService: NetFacadeService) {
		super(netFacadeService);
		this.schedule = null;
	}

	public ngOnInit() {

	}

	protected BuildForm(): void {
		if (this.schedComponent) {
			this.schedComponent.BuildForm();
		}
	}

	public ngOnChanges(changes: SimpleChanges): void {
		this.onChanges();

		if (this.Discovery) {
			this.schedule = this.Discovery.Schedule;
		}
		else {
			this.schedule = null;
		}
	}

	public applyTempChanges(): void {
		if (this.schedComponent) {
			this.schedComponent.applyTempChanges();
			this.onApplyTempChanges();
		}
	}

	public get invalidTempChanges(): string[] {
		return ["Schedule"];
	}

	public get tempChanges(): boolean {
		if (this.schedComponent) {
			return this.schedComponent.SettingsForm.dirty;
		}
		else {
			return false;
		}
	}

	public get tempChangesValid(): boolean {
		if (this.schedComponent) {
			return this.schedComponent.SettingsForm.valid;
		}
		else {
			return false;
		}
	}

}
